import { SITE, SOCIAL } from "@/config";

function GitHubIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden {...props}>
      <path d="M12 .5A11.5 11.5 0 0 0 .5 12.3c0 5.2 3.3 9.6 7.9 11.1.6.1.8-.3.8-.6v-2.2c-3.2.7-3.9-1.4-3.9-1.4-.5-1.2-1.2-1.5-1.2-1.5-1-.7.1-.7.1-.7 1.1.1 1.7 1.1 1.7 1.1 1 .1.9 1.9 2.9 1.4.1-.8.4-1.3.7-1.6-2.6-.3-5.3-1.4-5.3-6.1 0-1.3.5-2.4 1.2-3.3-.1-.3-.6-1.6.1-3.4 0 0 1-.3 3.4 1.2a11.6 11.6 0 0 1 6.1 0c2.4-1.5 3.4-1.2 3.4-1.2.7 1.8.2 3.1.1 3.4.8.9 1.2 2 1.2 3.3 0 4.7-2.7 5.8-5.3 6.1.4.3.8 1 .8 2.1v3.1c0 .3.2.7.8.6 4.7-1.5 7.9-5.9 7.9-11.1A11.5 11.5 0 0 0 12 .5z" />
    </svg>
  );
}
function LinkedInIcon(props) {
  return (
    <svg viewBox="0 0 16 16" fill="currentColor" aria-hidden {...props}>
      <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854zM4.943 13.394V6.169H2.542v7.225zm-.943-8.473c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248S2.4 3.226 2.4 3.934c0 .694.521 1.248 1.327 1.248zM13.458 13.394V9.359c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193V6.169H6.129c.03.678 0 7.225 0 7.225h2.4V9.7c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401z" />
    </svg>
  );
}
function TwitterIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden {...props}>
      <path d="M19.6 7.4c.5-1 .8-2 .9-3-1 .6-2 .9-3.1 1.1A3.7 3.7 0 0 0 12 8.8c0 .3 0 .6.1.8C8.3 9.5 5.1 7.9 3 5.3c-.4.8-.6 1.6-.6 2.5 0 1.7.9 3.2 2.2 4.1-.8 0-1.5-.2-2.1-.6v.1c0 2.4 1.7 4.4 3.9 4.9-.4.1-.9.2-1.4.2-.3 0-.6 0-.8-.1.6 2 2.5 3.4 4.7 3.5A7.4 7.4 0 0 1 2 19.6a10.4 10.4 0 0 0 5.6 1.7c6.7 0 10.4-5.6 10.4-10.4v-.5c.7-.5 1.4-1.2 1.9-2z" />
    </svg>
  );
}
function InstagramIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden {...props}>
      <path d="M7 2h10a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5Zm5 5a5 5 0 1 0 0 10 5 5 0 0 0 0-10Zm6.5-.9a1.1 1.1 0 1 0 0 2.2 1.1 1.1 0 0 0 0-2.2Z" />
    </svg>
  );
}

export default function Footer() {
  const year = new Date().getFullYear();
  const socials = [
    { label: "GitHub", href: SOCIAL.github, Icon: GitHubIcon },
    { label: "LinkedIn", href: SOCIAL.linkedin, Icon: LinkedInIcon },
    { label: "Twitter", href: SOCIAL.twitter, Icon: TwitterIcon },
    { label: "Instagram", href: SOCIAL.instagram, Icon: InstagramIcon },
  ].filter((s) => !!s.href);

  return (
    <footer className="mt-24 border-t border-white/10 bg-gradient-to-b from-transparent to-black/5 dark:to-white/5">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-10 flex flex-col sm:flex-row items-center justify-between gap-6">
        <p className="text-sm text-gray-600 dark:text-gray-400">
          © {year} {SITE.name}. Designed with ❤️ & coffee.
        </p>

        <div className="flex items-center gap-5">
          {socials.map(({ label, href, Icon }) => (
            <a
              key={label}
              href={href}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300 hover:text-[--color-primary] transition-colors"
            >
              <Icon className="h-4 w-4" />
              <span className="sr-only sm:not-sr-only sm:inline">{label}</span>
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
}